import { mapActions, mapGetters, mapState } from "vuex";

export const baseSpeedBidManagement = {
  computed: {
    ...mapState(['items', 'bids', 'temporaryBidItemsIsLoading']),
    ...mapGetters(['getItem']),

    speedBidItems() {
      if (!this.temporaryBidItemsIsLoading) {
        return this.bids.map(sb => {
          return this.formatBidItem(this.getItem(parseInt(sb.id, 10)), sb.amount);
        });
      }

      return [];
    }
  },
  methods: {
    ...mapActions(['SET_STATE']),
    formatBidItem(bidItem, maxBid) {
      const { title, lot, currentBid, startingPrice, errorText, userBidStatus } = bidItem;

      return {
        bidStatus: userBidStatus?.status,
        currentBid: currentBid || startingPrice,
        errorText,
        lot,
        maxBid,
        title,
      }
    },
    clearSelectedItems() {
      this.SET_STATE([{stateName: 'bids', data: []}]);
    }
  }
}